<form [formGroup]="unitForm">
    <div class="row">

        <!-- header context info -->
        <div class="col-12">
            <figure class="text-center">
                <figcaption class="blockquote mb-1">
                    {{ TRANSLATE_KEY_MAP.FORM.LEVEL.LABEL() | translate }}: <strong>{{targetLevel()}}</strong>
                </figcaption>
                <blockquote class="blockquote mb-0">
                    @if (isCreationMode()) {
                        <p>{{ TRANSLATE_KEY_MAP.FORM.PARENT.LABEL() | translate }}: <strong>{{relatedUnit()?.name}}</strong></p>
                    } @else {
                        <p>{{ TRANSLATE_KEY_MAP.FORM.NAME.LABEL() | translate }}: <strong>{{relatedUnit()?.name}}</strong></p>
                    }
                </blockquote>
            </figure>
        </div>

        <!-- Name -->
        <div class="col-12 col-md-6 mb-3">
            <app-input-field
                name="name"
                identifier="name"
                formControlName="name"
                [label]="TRANSLATE_KEY_MAP.FORM.NAME.LABEL() | translate"
                [placeholder]="TRANSLATE_KEY_MAP.FORM.NAME.PLACEHOLDER() | translate"
            />
        </div>

        <!-- Type -->
        <div class="col-12 col-md-6 mb-3">
            <label class="form-label">{{ TRANSLATE_KEY_MAP.FORM.TYPE.LABEL() | translate }}</label>
            <ng-select
                [clearable]="false"
                bindValue="id"
                bindLabel="name"
                formControlName="type_id"
                [items]="filteredUnitTypes()"
                [placeholder]="TRANSLATE_KEY_MAP.FORM.TYPE.PLACEHOLDER() | translate"
            />
            @let typeIdControl = unitForm.get('type_id');

            @if(typeIdControl?.touched && typeIdControl?.invalid) {
                <div class="d-block" appFormFieldFeedback="invalid">{{ 'FORM.VALIDATION.REQUIRED' | translate }}</div>
            }
        </div>

        <!-- Description -->
        <div class="col-12 mb-3">
            <app-textarea
                name="description"
                identifier="description"
                formControlName="description"
                [label]="TRANSLATE_KEY_MAP.FORM.DESCRIPTION.LABEL() | translate"
                [placeholder]="TRANSLATE_KEY_MAP.FORM.DESCRIPTION.PLACEHOLDER() | translate"
            />
        </div>

        <!-- Parent unit (disabled) -->
        <!-- <div class="col-12 col-md-6 mb-4">
            <app-input-field
                name="parent_id"
                identifier="parent_id"
                formControlName="parent_id"
                [label]="TRANSLATE_KEY_MAP.FORM.PARENT.LABEL() | translate"
                [placeholder]="TRANSLATE_KEY_MAP.FORM.PARENT.PLACEHOLDER() | translate"
            />
        </div> -->

        <!-- Level (disabled) -->
        <!-- <div class="col-12 col-md-6 mb-4">
            <app-input-field
                type="number"
                [valueAsNumber]="true"
                name="level"
                identifier="level"
                formControlName="level"
                [label]="TRANSLATE_KEY_MAP.FORM.LEVEL.LABEL() | translate"
                [placeholder]="TRANSLATE_KEY_MAP.FORM.LEVEL.PLACEHOLDER() | translate"
            />
        </div> -->

        <!-- Icon (empty list — placeholder for future) -->
        <!-- <div class="col-12 col-md-6 mb-4">
            <label class="form-label">{{ TRANSLATE_KEY_MAP.FORM.ICON.LABEL() | translate }}</label>
            <ng-select
                bindValue="id"
                bindLabel="name"
                formControlName="icon_id"
                [items]="[]"
                [placeholder]="TRANSLATE_KEY_MAP.FORM.ICON.PLACEHOLDER() | translate"
            />
        </div> -->

        <!-- Latitude -->
        <div class="col-12 col-md-5 mb-3">
            <app-input-field
                type="number"
                name="latitude"
                identifier="latitude"
                formControlName="latitude"
                [label]="TRANSLATE_KEY_MAP.FORM.LATITUDE.LABEL() | translate"
                [placeholder]="TRANSLATE_KEY_MAP.FORM.LATITUDE.PLACEHOLDER() | translate"
            />
        </div>

        <!-- Longitude -->
        <div class="col-12 col-md-5 mb-3">
            <app-input-field
                type="number"
                name="longitude"
                identifier="longitude"
                formControlName="longitude"
                [label]="TRANSLATE_KEY_MAP.FORM.LONGITUDE.LABEL() | translate"
                [placeholder]="TRANSLATE_KEY_MAP.FORM.LONGITUDE.PLACEHOLDER() | translate"
            />
        </div>

        <!-- Color -->
        <div class="col-2 mb-3">
            <app-input-field
                [ignoreStatus]="'valid'"
                name="html_hex_color"
                identifier="html_hex_color"
                type="color"
                formControlName="html_hex_color"
                [label]="TRANSLATE_KEY_MAP.FORM.COLOR.LABEL() | translate"

            />
        </div>

        <!-- X Coordinate -->
        <!-- <div class="col-12 col-md-6 mb-3">
            <app-input-field
                type="number"
                name="x_coordinate"
                identifier="x_coordinate"
                formControlName="x_coordinate"
                [label]="TRANSLATE_KEY_MAP.FORM.X_COORD.LABEL() | translate"
                [placeholder]="TRANSLATE_KEY_MAP.FORM.X_COORD.PLACEHOLDER() | translate"
            />
        </div> -->

        <!-- Y Coordinate -->
        <!-- <div class="col-12 col-md-6 mb-3">
            <app-input-field
                type="number"
                name="y_coordinate"
                identifier="y_coordinate"
                formControlName="y_coordinate"
                [label]="TRANSLATE_KEY_MAP.FORM.Y_COORD.LABEL() | translate"
                [placeholder]="TRANSLATE_KEY_MAP.FORM.Y_COORD.PLACEHOLDER() | translate"
            />
        </div> -->

    </div>

    <!-- Map: two-way coordinate editing -->
    <div class="mt-3">
        <google-map
            width="100%"
            height="300px"
            [zoom]="15"
            [center]="mapCenter()"
            [options]="mapOptions"
            (mapClick)="onMapClick($event)"
        >
            <map-marker
                [position]="mapMarker()"
                [options]="{ draggable: true }"
                (mapDragend)="onMarkerDragEnd($event)"
            />
        </google-map>
    </div>

</form>
